import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function EnterWarehouseDetailsList() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
